// const source = 'podsDataTable'

function downloadConsumiDispacciamento () {

  

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-consumi-dispacciamento',
      title: 'CONSUMI DISPACCIAMENTO',
      data: [],
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': downloadConsumiDispacciamento,
}
